<div class="inputFieldset">
  <fieldset class="conditionInputs">
    <legend>Cooling Conditions</legend>
    <div class="configurationDetailRow">
      @if (coolingEnteringDryBulbSelection) {
        <span>
          <span class="configurationInputLabel">Entering Dry Bulb:</span>
          <input type="number" class="configurationRatingTextInput" #coolingEnteringDryBulbInput
            [value]="coolingEnteringDryBulbSelection.Value" step="0.1"
            (change)="selectionChanged(coolingEnteringDryBulbSelection, coolingEnteringDryBulbInput.value || '0')">
          <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (coolingEnteringWetBulbSelection) {
        <span>
          <span class="configurationInputLabel">Entering Wet Bulb:</span>
          <input type="number" class="configurationRatingTextInput" #coolingEnteringWetBulbInput
            [value]="coolingEnteringWetBulbSelection.Value" step="0.1"
            (change)="selectionChanged(coolingEnteringWetBulbSelection, coolingEnteringWetBulbInput.value || '0')">
          <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (coolingEnteringFluidTemperatureSelection) {
        <span>
          <span class="configurationInputLabel">Entering Fluid Temp:</span>
          <input type="number" class="configurationRatingTextInput" #coolingEnteringFluidTemperatureInput
            [value]="coolingEnteringFluidTemperatureSelection.Value" step="0.1"
            (change)="selectionChanged(coolingEnteringFluidTemperatureSelection, coolingEnteringFluidTemperatureInput.value || '0')">
          <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (coolingFluidTypeSelection) {
        <span>
          <span class="configurationInputLabel">Fluid Type:</span>
          <select class="configurationRatingTextInput" #coolingFluidTypeInput
            (change)="selectionChanged(coolingFluidTypeSelection, coolingFluidTypeInput.value)"
            [value]="coolingFluidTypeSelection.Value">
            @for (allowable of coolingFluidTypeSelection.Allowables; track allowable) {
              <option
                class="configurationSelectionOption" [value]="allowable.Value"
                            [selected]="coolingFluidTypeSelection.Value
                             && coolingFluidTypeSelection.Value.toString() === allowable.Value">
                {{ allowable.Description }}
              </option>
            }
          </select>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (coolingGlycolPercentageSelection) {
        <span>
          <span class="configurationInputLabel">Glycol %:</span>
          <input type="number" class="configurationRatingTextInput" #coolingGlycolPercentageInput
            [value]="coolingGlycolPercentageSelection.Value" step="0.1"
            (change)="selectionChanged(coolingGlycolPercentageSelection, coolingGlycolPercentageInput.value || '0')">
        </span>
      }
    </div>
    @if (!isSureflow()) {
      <div class="configurationDetailRow">
        <span>
          <span class="configurationInputLabel">
            <select #coolingDeltaTypeInput class="deltaInputField configurationInputField"
              (change)="deltaSelectionChanged(true, coolingDeltaTypeInput.value)"
              [value]="selectedCoolingDelta">
              @for (allowable of deltaSelections; track allowable) {
                <option [selected]="allowable === selectedCoolingDelta" [value]="allowable">{{ allowable }}</option>
              }
            </select>
          </span>
          <input type="number" class="configurationRatingTextInput" #coolingDeltaValueInput
            [value]="coolingDeltaValue" step="0.1"
            (change)="deltaValueChanged(true, coolingDeltaValueInput.value || '0')">
          <span class="configurationRatingUnitLabel">{{ getCoolingDeltaUnits() }}</span>
        </span>
        <span>
        </span>
      </div>
    }
  </fieldset>
</div>
<div class="inputFieldset">
  <fieldset class="conditionInputs">
    <legend>Heating Conditions</legend>
    <div class="configurationDetailRow">
      @if (heatingEnteringDryBulbSelection) {
        <span>
          <span class="configurationInputLabel">Entering Dry Bulb:</span>
          <input type="number" class="configurationRatingTextInput" #heatingEnteringDryBulbInput
            [value]="heatingEnteringDryBulbSelection.Value" step="0.1"
            (change)="selectionChanged(heatingEnteringDryBulbSelection, heatingEnteringDryBulbInput.value || '0')">
          <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (heatingEnteringFluidTemperatureSelection) {
        <span>
          <span class="configurationInputLabel">Entering Fluid Temp:</span>
          <input type="number" class="configurationRatingTextInput" #heatingEnteringFluidTemperatureInput
            [value]="heatingEnteringFluidTemperatureSelection.Value" step="0.1"
            (change)="selectionChanged(heatingEnteringFluidTemperatureSelection, heatingEnteringFluidTemperatureInput.value || '0')">
          <span class="configurationRatingUnitLabel">{{ getTemperatureUnits() }}</span>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (heatingFluidTypeSelection) {
        <span>
          <span class="configurationInputLabel">Fluid Type:</span>
          <select class="configurationRatingTextInput" #heatingFluidTypeInput
            (change)="selectionChanged(heatingFluidTypeSelection, heatingFluidTypeInput.value)"
            [value]="heatingFluidTypeSelection.Value">
            @for (allowable of heatingFluidTypeSelection.Allowables; track allowable) {
              <option
                class="configurationSelectionOption" [value]="allowable.Value"
                            [selected]="heatingFluidTypeSelection.Value
                             && heatingFluidTypeSelection.Value.toString() === allowable.Value">
                {{ allowable.Description }}
              </option>
            }
          </select>
        </span>
      }
    </div>
    <div class="configurationDetailRow">
      @if (heatingGlycolPercentageSelection) {
        <span>
          <span class="configurationInputLabel">Glycol %:</span>
          <input type="number" class="configurationRatingTextInput" #heatingGlycolPercentageInput
            [value]="heatingGlycolPercentageSelection.Value" step="0.1"
            (change)="selectionChanged(heatingGlycolPercentageSelection, heatingGlycolPercentageInput.value || '0')">
        </span>
      }
    </div>
    @if (!isSureflow()) {
      <div class="configurationDetailRow">
        <span>
          <span class="configurationInputLabel">
            <select #heatingDeltaTypeInput class="deltaInputField configurationInputField"
              (change)="deltaSelectionChanged(false, heatingDeltaTypeInput.value)"
              [value]="selectedHeatingDelta">
              @for (allowable of deltaSelections; track allowable) {
                <option [selected]="allowable === selectedHeatingDelta" [value]="allowable">{{ allowable }}</option>
              }
            </select>
          </span>
          <input type="number" class="configurationRatingTextInput" #heatingDeltaValueInput
            [value]="heatingDeltaValue" step="0.1"
            (change)="deltaValueChanged(false, heatingDeltaValueInput.value || '0')">
          <span class="configurationRatingUnitLabel">{{ getHeatingDeltaUnits() }}</span>
        </span>
        <span>
        </span>
      </div>
    }
  </fieldset>
</div>
